import React from 'react'
import { FormCheckbox, FormDate } from '@myxplor/forms'

const RiskReasons = ({ readOnly, onChange, values, isDetermination }) => {
  return (
    <fieldset>
      <legend>2. Risk Reasons</legend>
      Choose the risks that {values.name} is facing which apply to this
      certificate, you are able to select more than one option.
      <FormCheckbox
        label={
          'Under care and protection of State/Territory child protection legislation.'
        }
        name={'risk_reasons.COSTB'}
        value={values.risk_reasons.COSTB}
        onChange={onChange}
        compact
      />
      <FormCheckbox
        label={'Being subjected to sexual abuse.'}
        name={'risk_reasons.SABUSE'}
        value={values.risk_reasons.SABUSE}
        onChange={onChange}
        compact
      />
      <FormCheckbox
        label={
          'Suffering harm due to physical, emotional or psychological abuse.'
        }
        name={'risk_reasons.ABUSED'}
        value={values.risk_reasons.ABUSED}
        onChange={onChange}
        compact
      />
      <FormCheckbox
        label={
          'Suffering as a result of exposure to domestic or family violence.'
        }
        name={'risk_reasons.DOMVIO'}
        value={values.risk_reasons.DOMVIO}
        onChange={onChange}
        compact
      />
      <FormCheckbox
        label={'Suffering, or is at risk of suffering harm caused by neglect.'}
        name={'risk_reasons.NEGLEC'}
        value={values.risk_reasons.NEGLEC}
        onChange={onChange}
        compact
      />
      Suffered in the <strong>past</strong> due to...
      <FormCheckbox
        label={'Experiencing physical, emotional or psychological abuse.'}
        name={'risk_reasons.ABPAST'}
        value={values.risk_reasons.ABPAST}
        onChange={onChange}
        compact
      />
      <FormCheckbox
        label={'Being subjected to sexual abuse.'}
        name={'risk_reasons.SAPAST'}
        value={values.risk_reasons.SAPAST}
        onChange={onChange}
        compact
      />
      <FormCheckbox
        label={'Exposure to domestic or family violence.'}
        name={'risk_reasons.VIPAST'}
        value={values.risk_reasons.VIPAST}
        onChange={onChange}
        compact
      />
      <FormCheckbox
        label={'Experiencing neglect.'}
        name={'risk_reasons.NEGPST'}
        value={values.risk_reasons.NEGPST}
        onChange={onChange}
        compact
      />
      {isDetermination && (
        <FormDate
          required={true}
          disabled={readOnly}
          label={'Indicative Risk to Date'}
          name={'indicative_risk_to_date'}
          value={values.indicative_risk_to_date}
          onChange={onChange}
          today
        />
      )}
    </fieldset>
  )
}

export default RiskReasons



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/risk-reasons.js